import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { withDefaults } from 'vue'
import { useRouter } from 'vue-router'
import { IonToolbar, IonTitle, IonButton, IonButtons, IonBackButton, IonIcon } from '@ionic/vue'
import { home, logOutOutline } from 'ionicons/icons'
import { useIncidenciaStore } from '@/stores/incidencia-store'

interface Props {
  title?: string,
  homeButton?: boolean,
  backButton?: boolean,
  backButtonDefault?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormToolbar',
  props: {
    title: { default: 'Nueva incidencia' },
    homeButton: { type: Boolean, default: true },
    backButton: { type: Boolean, default: true },
    backButtonDefault: {}
  },
  setup(__props: any) {



const store = useIncidenciaStore()
const router = useRouter()

const logout = async () => {
  await router.push('/')
  setTimeout(() => {
    store.logout()
    store.resetList()
  }, 300)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonToolbar), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonButtons), { slot: "start" }, {
        default: _withCtx(() => [
          (_ctx.backButton)
            ? (_openBlock(), _createBlock(_unref(IonBackButton), {
                key: 0,
                text: "",
                "default-href": _ctx.backButtonDefault
              }, null, 8, ["default-href"]))
            : _createCommentVNode("", true),
          (_ctx.homeButton)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 1,
                "router-link": "/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(home)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonTitle), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }),
      (_unref(store).isLoggedIn)
        ? (_openBlock(), _createBlock(_unref(IonButtons), {
            key: 0,
            slot: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                title: "Desconectar",
                onClick: logout
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(logOutOutline)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})